import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  id: "label",
  class: "w-fit text-xs"
};
const _hoisted_2 = ["focus-group"];
const _hoisted_3 = ["title"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onUpdate:modelValue", "onInput"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_InfoComponent = _resolveComponent("InfoComponent");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full flex flex-col", [this.size, this.variant, {
      'error': _ctx.hasError
    }]])
  }, [_ctx.label ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.label), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "relative flex flex-col gap-2",
    tabindex: "0",
    "focus-group": _ctx.dropdownID,
    onFocus: _cache[1] || (_cache[1] = $event => this.$handleFocusGroup(() => this.showMenu = false))
  }, [_createElementVNode("div", {
    id: "dropdown-header",
    class: "relative flex items-center justify-between gap-2 cursor-pointer",
    onClick: _cache[0] || (_cache[0] = $event => this.showMenu = !this.showMenu)
  }, [_createElementVNode("p", {
    class: "truncate",
    title: $options.selectedItemText
  }, _toDisplayString($options.selectedItemText || _ctx.translate('general.select')), 9, _hoisted_3), _cache[2] || (_cache[2] = _createElementVNode("i", {
    class: "icon-chevron-down text-lg!"
  }, null, -1))]), this.showMenu ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    id: "dropdown-menu",
    class: _normalizeClass(["w-full top-[calc(100%+6px)] left-0 flex flex-col gap-1 z-10 shadow-weak_material", {
      'absolute animate-dropdown': this.floating
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.items, item => {
    return _openBlock(), _createElementBlock("div", {
      id: "dropdown-item",
      key: item,
      class: _normalizeClass(["relative flex items-center gap-2 transition-[background] cursor-pointer", [this.size, this.variant, {
        'selected': this.value?.toString() && this.value === item.value
      }]]),
      onClick: $event => this.HandleItemClick(item)
    }, [_createElementVNode("p", null, _toDisplayString(item.label), 1), item.input ? _withDirectives((_openBlock(), _createElementBlock("input", {
      key: 0,
      id: "extra-input",
      "onUpdate:modelValue": $event => item.value = $event,
      onInput: $event => this.value = item.value,
      type: "text",
      spellcheck: "false",
      class: "w-full cursor-text! z-10 outline-none border-none bg-transparent pb-0.5"
    }, null, 40, _hoisted_5)), [[_vModelText, item.value]]) : _createCommentVNode("", true)], 10, _hoisted_4);
  }), 128))], 2)) : _createCommentVNode("", true)], 40, _hoisted_2), _createVNode(_component_InfoComponent, {
    data: _ctx.validationStatus,
    class: "mt-1.5"
  }, null, 8, ["data"])], 2);
}